module.exports = "<form>\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\">Are you sure that you want to edit completed ticket?</h3>\n    </div>\n    <div class=\"modal-body\">\n        This ticket has already been completed.\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.edit()\">Edit</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n    </div>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tickets/templates/confirm.edit.modal.html
// module id = 658
// module chunks = 0